// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"361":"4af128da","453":"c1b6b4ef","467":"f47ecf41","551":"4d61fe61","608":"d0672e7f","703":"41bdf8af"}[chunkId] + ".chunk.js";
};